module.exports = __webpack_public_path__ + "images/柏纳长图_08-1.jpg?v=aa106158";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan1/柏纳长图_08-1.jpg
 ** module id = 148
 ** module chunks = 1 2
 **/